(ns ductile.ui.vin-list
  (:require [applied-science.js-interop :as j]
            [clojure.string :as str]
            [ductile.compound-config :as compound-config]
            [ductile.time.format :as time.format]
            [ductile.ui.components :as ui]
            [ductile.ui.components.combobox :as combobox]
            [ductile.ui.deframe :as deframe]
            [ductile.ui.forms :as forms.ui]
            [ductile.ui.http :as http]
            [ductile.ui.locale :refer [tr]]
            [ductile.ui.mobile :as mobile]
            [ductile.ui.router :as router]
            [ductile.ui.scanner :as scanner]
            [ductile.ui.scene :as scene]
            [ductile.ui.util :as util]
            [inside-out.forms :as forms]
            [inside-out.reagent :refer [with-form]]
            [kitchen-async.promise :as p]
            [nextjournal.log :as log]
            [reagent.core :as r])
  (:require-macros [ductile.ui.scene.macros :refer [defscene]]))

(defn vehicles-count [count]
  [:span.font-bold.border.border-gray-200.px-2.rounded-full.flex.items-center
   {:class "py-[2px] bg-white bg-opacity-30"}
   [:span.mr-1 count]
   [ui/icon :car]])

(defn add-scan [scan vin-list-id]
  (p/let [result (http/$lambda 'ductile.vin-list/handle-upsert-vin
                               (if (:scan/id scan)
                                 ;; link (ocr) scan entity to vin-list
                                 {:scan/id (:scan/id scan)
                                  :ductile/id vin-list-id}
                                 ;; create a new scan for barcodes
                                 {:scan/result (:scan/result scan)
                                  :ductile/id vin-list-id}))]
    (if-let [error-message (:error-message result)]
      (deframe/route-assoc! ::notice {:type :error :message error-message
                                      :on-close (fn [] (deframe/route-dissoc! ::notice))})
      (deframe/route-update-in!
       [:vin-list :vin-list/scans]
       (fn [scans] (conj scans
                         {:scan/result (:scan/result scan)
                          :ductile/created-at (js/Date.)
                          :ductile/id (:ductile/id result)}))))
    (deframe/reset-current-scan!)))

(defn scanner-view []
  (when @deframe/!scan-active?
    [:div.fixed.left-0.top-0.w-screen.h-screen {:style {:z-index 999}}
     [scanner/scanner-view {:width js/innerWidth
                            :height js/innerHeight
                            :scan/context :vin-list
                            :scanning-mode (scanner/scan-mode :vin)
                            :on-vin-detected (fn [_state body]
                                               (let [{:keys [vin]} body]
                                                 (deframe/scan! {:scan/attr :vehicle/vin
                                                                 :scan/id (-> body :scan :ductile/id)
                                                                 :scan/result vin
                                                                 :scan/ocr-details body
                                                                 :scan/classified (scanner/classify-scan vin)
                                                                 :scan/source :camera})
                                                 (deframe/close-scanner!)))
                            :on-ocr-error (fn [_state error]
                                            (deframe/close-scanner!)
                                            (deframe/route-assoc! ::notice {:type :error :message (:error-message error)
                                                                            :on-close (fn [] (deframe/route-dissoc! ::notice))}))}]
     [:div.fixed.right-2.top-2.text-white.z-10.cursor-pointer
      {:on-click #(deframe/close-scanner!)}
      [ui/icon {:size 30} :x]]]))

(def with-hardware-scanner (partial ui/with-hardware-scanner scanner-view))

(defn send-mode []
  (let [{:ductile/keys [id created-at] :vin-list/keys [scans email]} @(deframe/!route-get :vin-list)]
    (with-form [!form {:email ?email}
                :required [?email]
                :meta {?email {:init email
                               :validators [(fn [email _]
                                              (when (and email
                                                         (not (str/blank? email))
                                                         (not (re-find util/email-regex email)))
                                                {:type :invalid
                                                 :content (tr "Email must be valid")}))]}}]
      [:form {:on-submit #(do (.preventDefault %)
                              (if (forms/submittable? !form)
                                (forms/watch-promise
                                 !form
                                 (p/let [result (http/$lambda 'ductile.vin-list/handle-send-email
                                                              {:email @?email
                                                               :ductile/id id})]
                                   (if-let [error-message (:error-message result)]
                                     (deframe/route-assoc! ::notice {:type :error :message error-message
                                                                     :on-close (fn [] (deframe/route-dissoc! ::notice))})
                                     (do (deframe/route-assoc! ::notice {:type :success :message (tr "VIN list emailed successfully")
                                                                         :on-close (fn [] (deframe/route-dissoc! ::notice))})
                                         (deframe/route-dissoc! :send-mode?)))))
                                (forms/touch! !form)))}
       [mobile/scroll-content
        [mobile/navbar {:title [:div.flex.items-center
                                [:span.mr-2 (time.format/->str {:locale :it :format :datetime} created-at)]
                                [vehicles-count (count scans)]]
                        :back [mobile/back-link {:on-click #(do (.preventDefault %)
                                                                (deframe/route-dissoc! :send-mode?))}]}]
        (when-let [notice @(deframe/!route-get ::notice)]
          [ui/flash-notice notice])

        [mobile/table
         {:title (tr "Email")
          :items [[mobile/list-item
                   {:title [forms.ui/input-text ?email {:class "border-none shadow-none w-full text-xs"
                                                        :placeholder (tr "Provide an email address")}]}]]}]
        [mobile/toolbar
         [mobile/button-full
          {:type "submit"
           :style {:height 50}}
          [:span.mx-2 [ui/icon :email]]
          [:span (tr "Send %1 VINs" (count scans))]]]]
       (into [:div]
             (map forms.ui/view-message)
             (forms/visible-messages !form))])))

(defn list-mode [compound-name]
  (let [{:ductile/keys [created-at id] :vin-list/keys [scans title]} @(deframe/!route-get :vin-list)]
    (r/with-let [vin-editing (r/atom nil)
                 new-title (r/atom nil)]
      [:div
       [mobile/scroll-content
        [mobile/navbar {:title [:div.flex.items-center
                                [:span.mr-2 (time.format/->str {:locale :it :format :datetime} created-at)]
                                [vehicles-count (count scans)]]
                        :back [mobile/back-link {:route (router/path '[vin-list :compound/name] {:compound/name compound-name})}]}]
        (when-let [notice @(deframe/!route-get ::notice)]
          [ui/flash-notice notice])
        [mobile/table
         {:title (tr "Title")
          :items [[mobile/list-item
                   {:title (if (or @new-title (empty? title))
                             [:div.flex.items-center
                              [ui/input {:value (or @new-title "")
                                         :placeholder "Provide a title"
                                         :class "flex-grow border-none shadow-none"
                                         :on-input #(do (reset! new-title (j/get-in % [:target :value]))
                                                        (r/flush))
                                         :size 3}]
                              [:button.ml-2.mr-1.text-green-500.disabled:text-green-200
                               {:disabled (not @new-title)
                                :data-testid "edit-title-confirm"
                                :on-click #(p/let [result (http/$lambda 'ductile.vin-list/handle-update
                                                                        {:title @new-title
                                                                         :ductile/id id})]
                                             (if-let [error-message (:error-message result)]
                                               (deframe/route-assoc! ::notice {:type :error :message error-message
                                                                               :on-close (fn [] (deframe/route-dissoc! ::notice))})
                                               (do
                                                 (deframe/route-assoc-in! [:vin-list :vin-list/title] @new-title)
                                                 (reset! new-title nil))))}
                               [ui/icon {:size 30} :check-circle]]
                              [:button.mx-2.text-red-400
                               {:on-click #(reset! new-title nil)}
                               [ui/icon {:size 30} :x-circle]]]
                             [:div.flex.items-center.justify-between
                              [:div title]
                              [:button.px-3.py-1.font-medium.border.rounded.mx-2.flex.text-center.justify-center.items-center.appearance-none.transition-colors.focus:outline-none.cursor-pointer.select-none.overflow-hidden.z-10.relative.duration-100.active:bg-opacity-15.h-11
                               {:on-click #(reset! new-title title)
                                :data-testid "edit-title"}
                               (tr "Edit")]])}]]}]
        [mobile/table
         {:items (mapv (fn [{vin :scan/result :as scan}]
                         [mobile/list-item
                          {:title
                           [:div.w-full.flex-auto.flex.items-center.justify-between
                            (if-not (= (:ductile/id @vin-editing) (:ductile/id scan))
                              [:div.flex.items-center.justify-between.w-full
                               [:div.mr-1 vin]
                               [:button.px-3.py-1.font-medium.border.rounded.mx-2.flex.text-center.justify-center.items-center.appearance-none.transition-colors.focus:outline-none.cursor-pointer.select-none.overflow-hidden.z-10.relative.duration-100.active:bg-opacity-15.h-11
                                {:data-testid "edit-vin"
                                 :on-click #(do (swap! vin-editing assoc :old-vin vin)
                                                (swap! vin-editing assoc :new-vin vin)
                                                (swap! vin-editing assoc :ductile/id (:ductile/id scan)))}
                                [:span (tr "Edit")]]]
                              [:div.flex.items-center.justify-between.w-full.flex-auto
                               [ui/input {:value (:new-vin @vin-editing)
                                          :data-testid "edit-vin-input"
                                          :on-input #(do (swap! vin-editing assoc :new-vin (.. % -target -value))
                                                         (r/flush))
                                          :size 3}]
                               [:div.flex.items-center
                                [:button.ml-2.mr-1.text-green-500.disabled:text-green-200
                                 {:disabled (not= 17 (count (:new-vin @vin-editing)))
                                  :data-testid "edit-vin-confirm"
                                  :on-click #(p/let [new-vin (:new-vin @vin-editing)
                                                     result (http/$lambda 'ductile.vin-list/handle-update-vin
                                                                          {:new-vin new-vin
                                                                           :scan/id (:ductile/id scan)})]
                                               (when-let [error-message (:error-message result)]
                                                 (deframe/route-assoc! ::notice {:type :error :message error-message
                                                                                 :on-close (fn [] (deframe/route-dissoc! ::notice))}))
                                               (do (deframe/route-update-in!
                                                    [:vin-list :vin-list/scans]
                                                    (fn [scans] (map (fn [s]
                                                                       (cond-> s
                                                                         (= (:ductile/id scan) (:ductile/id s))
                                                                         (assoc :scan/result new-vin)))
                                                                     scans)))
                                                   (reset! vin-editing nil)))}
                                 [ui/icon {:size 30} :check-circle]]
                                [:button.mx-2.text-red-400
                                 {:on-click #(reset! vin-editing nil)}
                                 [ui/icon {:size 30} :x-circle]]]])]}])
                       (sort-by (comp - :ductile/created-at) scans))}]]
       [mobile/toolbar
        [:div.mr-2.flex-grow
         [mobile/button-full {:on-click (fn [_] (deframe/activate-scanner!))}
          [:span.mx-2 [ui/icon :scan]]
          [:span (tr "Add VIN")]]]
        [:div.ml-2.flex-grow
         [mobile/button-outline
          {:on-click #(deframe/route-assoc! :send-mode? true)}
          [:span.mx-2 [ui/icon :email]]
          [:span (tr "Send")]]]]])))

(defn vin-list-show [compound-name]
  [:div
   (if @(deframe/!route-get :send-mode?)
     [send-mode]
     (with-hardware-scanner
       {:view `vin-list-show
        :on-scan #(add-scan % @(deframe/!route-get-in [:vin-list :ductile/id]))}
       [list-mode compound-name]))])

(defn loading-or-view [view]
  (let [{:keys [loading error result]} @deframe/!current-route-fetch]
    (cond result
          [view result]

          loading
          [:div.bg-white.md:bg-gray-200.min-h-screen [ui/loading-spinner]]

          error
          [ui/error-view error])))

(defn render-vin-list-show [_result {:keys [path-params]}]
  [loading-or-view (fn [result]
                     (deframe/route-assoc! :vin-list result)
                     [(partial vin-list-show (:compound/name path-params))])])

(defn lists [compound-name lists]
  (let [open-lists (remove #(= :archived (:vin-list/status %)) lists)]
    [:div
     [mobile/scroll-content [mobile/navbar {:title (tr "VIN Lists")
                                            :back [mobile/back-link {:route "/"}]}]

      (when-let [notice @(deframe/!route-get ::notice)]
        [ui/flash-notice notice])
      [mobile/table
       {:items (mapv (fn [{:vin-list/keys [title scans] :as list}]
                       [mobile/list-item-disclose
                        {:title [:div.flex.items-center
                                 [:span.mr-2 (time.format/->str {:locale :it :format :datetime} (:ductile/created-at list))]
                                 [vehicles-count (count scans)]]
                         :subtitle
                         (if (str/blank? title)
                           [:span.mr-2.italic (tr "Untitled")]
                           [:span.mr-2 title])
                         :route (router/path '[vin-list :compound/name :ductile/id] {:compound/name compound-name
                                                                                     :ductile/id (:ductile/id list)})}])
                     open-lists)}]
      [mobile/toolbar
       [mobile/button-full {:on-click #(p/let [result (http/$lambda 'ductile.vin-list/handle-create
                                                                    {:compound/name compound-name})]
                                         (if-let [error-message (:error-message result)]
                                           (deframe/route-assoc! ::notice {:type :error :message error-message
                                                                           :on-close (fn [] (deframe/route-dissoc! ::notice))})
                                           (router/navigate-to (router/path '[vin-list :compound/name :ductile/id] {:compound/name compound-name
                                                                                                                    :ductile/id (:ductile/id result)}))))}
        [:span.mx-2 [ui/icon :scan]]
        [:span (tr "New list")]]]]]))

(defn show-title [title]
  (or (and (not (str/blank? title))
           title)
      (tr "Untitled")))

(defn vin-lists-table [vin-lists compound-name]
  (let [compound-locale (:compound/locale (compound-config/get-compound-config compound-name))]
    [:div.overflow-hidden.border-t
     [:table.min-w-full.divide-y.divide-gray-200
      [:thead.bg-gray-50
       [:tr
        [:th.pl-5.py-2.text-left.text-xs.font-medium.text-gray-500.uppercase.tracking-wider
         {:scope "col"}
         (tr "Description")]
        [:th.px-5.py-2.text-center.text-xs.font-medium.text-gray-500.uppercase.tracking-wider
         {:scope "col"}
         (tr "Vehicles")]
        [:th.px-5.py-2.text-right.text-xs.font-medium.text-gray-500.uppercase.tracking-wider
         {:scope "col"}
         (tr "Status")]]]
      (into [:tbody.bg-white.divide-y.divide-gray-200.text-sm]
            (if-not (empty? vin-lists)
              (map (fn [{:keys [ductile/id ductile/created-at vin-list/scans vin-list/title vin-list/status]}]
                     [:tr.hover:bg-gray-50.cursor-pointer {:on-click #(router/navigate-to (router/path '[compound :compound/name vin-lists-overview :ductile/id]
                                                                                                       {:compound/name "Piadena" :ductile/id id}))}
                      [:td.pl-5.py-2.whitespace-nowrap
                       [:div.flex.flex-col
                        [:span.font-bold (time.format/->str {:locale (or compound-locale :de) :format :datetime} created-at)]
                        [:span.font-bold.text-gray-500.text-xs.tracking-wide (show-title title)]]]
                      [:td.px-5.text-center.py-2.px-6.whitespace-nowrap.text-xs (count scans)]
                      [:td.px-5.py-2.px-6.whitespace-nowrap.text-xs.text-right
                       (if (= :archived status)
                         [ui/badge {:variant :white-gray
                                    :class "uppercase"}
                          (tr "Archived")]
                         [ui/badge {:variant :secondary
                                    :class "uppercase"}
                          (tr "Open")])]])
                   vin-lists)
              [[:tr [:td.p-5.text-center.font-bold.text-gray-500.text-sm {:colspan "3"}
                     (tr "No lists to show")]]]))]]))

(defn vin-lists-inspector [compound-name vin-lists]
  (r/with-let [selected (r/atom "open")
               choices [{:ui/value :all :ui/label (tr "All")}
                        {:ui/value :archived :ui/label (tr "Archived")}
                        {:ui/value :open :ui/label (tr "Open")}]]
    (let [value (some #(when (= @selected (:ui/value %)) %) choices)
          vin-lists-to-show (cond (= @selected :archived)
                                  (filterv #(= :archived (:vin-list/status %)) vin-lists)
                                  (= @selected :open)
                                  (vec (remove #(= :archived (:vin-list/status %)) vin-lists))
                                  :else
                                  vin-lists)]
      [ui/page
       [ui/top-bar]
       [:div.p-5.min-h-screen
        [:div.rounded.bg-white.border.shadow-sm
         [:div.border-b.bg-gray-50.px-5.py-2.rounded-t.flex.items-center.justify-between
          [:h2.text-base.font-bold (tr "VIN Lists")]
          [combobox/view
           {:value value
            :choices choices
            :class "w-40"
            :on-change #(reset! selected (:ui/value %))}]]
         [:div
          [vin-lists-table vin-lists-to-show compound-name]]]]])))

(defn process-list-view [compound-name {:ductile/keys [created-at id] :vin-list/keys [scans title status]}]
  (let [update-list-status (fn [status]
                             (p/let [result (http/$lambda 'ductile.vin-list/handle-update
                                                          {:status status
                                                           :ductile/id id})]
                               (if-let [error-message (:error-message result)]
                                 (deframe/route-assoc! ::notice {:type :error :message error-message
                                                                 :on-close (fn [] (deframe/route-dissoc! ::notice))})
                                 (router/navigate-to (router/path '[compound :compound/name vin-lists-overview] {:compound/name compound-name})))))]
    [ui/page
     [ui/top-bar]
     (when-let [notice @(deframe/!route-get ::notice)]
       [ui/flash-notice notice])
     [:div.p-5.min-h-screen
      [:div.flex.items-center.mb-4.justify-end
       [ui/button
        {:size 3
         :on-click #(router/navigate-to (router/path '[compound :compound/name vin-lists-overview] {:compound/name compound-name}))}
        [ui/icon :arrow-left]
        [:span.ml-1 (tr "VIN Lists")]]]
      [:div.bg-slate-50.px-4.pt-4.pb-2.rounded-t
       [:div.flex.items-center.justify-between
        [:div.tracking-wide.text-lg.font-bold (time.format/->str {:locale (or (:compound/locale (compound-config/get-compound-config compound-name)) :de) :format :datetime} created-at)]
        (if (= :archived status)
          [:div.flex.items-center
           [ui/badge {:variant :white-gray
                      :class "uppercase"}
            (tr "Archived")]
           [:button.mx-2.inline-flex.justify-center.rounded-md.border.border-gray-300.shadow-sm.px-4.py-2.bg-white.text-base.font-medium.text-gray-700.hover:bg-gray-50.focus:outline-none.focus:ring-2.focus:ring-offset-2.focus:ring-indigo-500.sm:mt-0.sm:col-start-1.sm:text-sm
            {:on-click #(update-list-status :open)}
            [ui/icon {:size 20} :refresh-ccw]
            [:span.ml-2 (tr "Reopen")]]]
          [:button.mx-2.inline-flex.justify-center.rounded-md.border.border-gray-300.shadow-sm.px-4.py-2.bg-white.text-base.font-medium.text-gray-700.hover:bg-gray-50.focus:outline-none.focus:ring-2.focus:ring-offset-2.focus:ring-indigo-500.sm:mt-0.sm:col-start-1.sm:text-sm
           {:on-click #(update-list-status :archived)}
           [ui/icon {:size 20} :archive]
           [:span.ml-2 (tr "Archive")]])]
       [:div.flex.items-center.my-2
        [:div.mr-2 [vehicles-count (count scans)]]
        [:div.text-gray-500.tracking-wide.text-sm.font-bold (show-title title)]]]
      [:div.overflow-hidden.border-t
       [:table.min-w-full.divide-y.divide-gray-200
        [:thead.bg-gray-50
         [:tr
          [:th.pl-5.py-2.text-left.text-xs.font-medium.text-gray-500.uppercase.tracking-wider
           {:scope "col"}
           (tr "VINs")]]]
        (into [:tbody.bg-white.divide-y.divide-gray-200.text-sm]
              (map (fn [s]
                     [:tr.hover:bg-gray-50
                      [:td.pl-5.py-2.whitespace-nowrap.text-xs (:scan/result s)]])
                   scans))]]]]))

(defn render-vin-lists [_result {:keys [path-params]}]
  [loading-or-view (partial lists (:compound/name path-params))])

(defn render-vin-lists-inspector [_result {:keys [path-params]}]
  [loading-or-view (partial vin-lists-inspector (:compound/name path-params))])

(defn render-process-vin-list [_result {:keys [path-params]}]
  [loading-or-view (partial process-list-view (:compound/name path-params))])

(def vin-list-1 {:vin-list/title "Bar"
                 :ductile/location {:compound/name "Piadena"}
                 :vin-list/scans #{{:scan/result "WBA51AJ0X0CH47698"
                                    :ductile/id #uuid"df3f0db4-7adc-4226-8664-1cf559956edf"
                                    :ductile/created-at #inst"2023-01-05T12:11:41.761088"}
                                   {:scan/result "WBA31DZ000FL53921"
                                    :ductile/id #uuid"81e314a6-9ae4-44e9-8374-27c3e66ce8ec"
                                    :ductile/created-at #inst"2023-01-06T12:13:41.761088"}}})
(def vin-list-2 {:vin-list/title "Foo"
                 :ductile/id #uuid"f29cce57-2895-4717-a810-7e910615f528"
                 :ductile/location {:compound/name "Piadena"}
                 :vin-list/scans #{{:scan/result "WBA51AJ0X0CH47698"
                                    :ductile/id #uuid"2bb13b8f-a4bb-4753-a143-a2220bfb5c97"
                                    :ductile/created-at #inst"2023-01-05T12:11:41.761088"}
                                   {:scan/result "WBA51AJ0X0CH47739"
                                    :ductile/id #uuid"849b968a-cecb-4adf-baba-d75c14e3a149"
                                    :ductile/created-at #inst"2023-01-06T12:13:41.761088"}}})

(def demo-lists [{:ductile/id #uuid "9ac479e7-12f9-4575-a0b7-9d686d7d1828"
                  :vin-list/title "My test list"
                  :vin-list/status :archived
                  :vin-list/scans [{:ductile/id #uuid "2c82f2c1-a3d1-433c-8868-99f565e7dc21", :scan/type "code_39", :scan/result "WBA31DZ000FL53921", :scan/source :camera, :scan/context :vin-list}
                                   {:ductile/id #uuid"808764b4-d4e9-4c8b-9725-53818d6a630f", :scan/type "code_39", :scan/result "2A48B145X99880534", :scan/source :camera, :scan/context :vin-list}
                                   {:ductile/id #uuid"eed5a412-b3eb-4dbe-bffd-7fe4555c09c6", :scan/type "code_39", :scan/result "ZDM59HIX2XH713201", :scan/source :camera, :scan/context :vin-list}
                                   {:ductile/id #uuid"8930be4e-ea02-48b5-a661-cc7b9042b974", :scan/type "code_39", :scan/result "YV4R009U14B664389", :scan/source :camera, :scan/context :vin-list}]
                  :ductile/location {:db/id [:ductile/id #uuid "324f7ce9-7010-4e66-bbab-9581e2c270c3"]}
                  :ductile/created-at #inst"2023-01-19T10:50:32.626093Z"}
                 {:ductile/id #uuid"f97230ab-1137-445a-9e84-21930a2df55b"
                  :vin-list/scans [{:ductile/id #uuid"91c5ad36-b97a-4f70-9887-ccb57470c57a", :scan/type "code_39", :scan/result "6F578A3O29Q267072", :scan/source :camera, :scan/context :vin-list}
                                   {:ductile/id #uuid"3824b653-0001-44b8-9e71-83b1cabe7616", :scan/type "code_39", :scan/result  "2FZ49UDUX98759195", :scan/source :camera, :scan/context :vin-list}]
                  :ductile/location {:db/id [:ductile/id #uuid "324f7ce9-7010-4e66-bbab-9581e2c270c3"]}
                  :ductile/created-at #inst"2023-01-17T10:50:44.295352Z"}
                 {:ductile/id #uuid"26de8daf-936b-4420-b529-9e424b5fc525"
                  :vin-list/status :archived
                  :vin-list/title "We don't know where these cars come from"
                  :vin-list/scans [{:ductile/id #uuid"55477cd5-7482-4f49-8b15-07ba134cf4bb", :scan/type "code_39", :scan/result  "MAKG3B4V3U6715723", :scan/source :camera, :scan/context :vin-list}]
                  :ductile/location {:db/id [:ductile/id #uuid "324f7ce9-7010-4e66-bbab-9581e2c270c3"]}
                  :ductile/created-at #inst "2023-01-19T09:49:20.659-00:00"}])

;; NOTE: the defscene's are not longer in working order after the UI started using deframe to state.
(defscene lists-card
  :params (atom nil)
  [!state]
  [lists {:notice !state
          :lists #{vin-list-1 vin-list-2}}])


(defscene vin-list-show-card
  :params (atom nil)
  [!state]
  [list-mode {:notice !state
              :ductile/id #uuid"56822da8-c355-4d76-ae06-89c95dfefbba"
              :vin-list vin-list-1}])

(defscene vin-list-send
  :params (atom nil)
  [!state]
  [send-mode vin-list-1 !state])

(defscene vin-list-send-error
  :params (atom {:type :error :message (tr "Unable to send email")})
  [!state]
  [send-mode vin-list-1 !state])

(defscene vin-list-send-ok
  :params (atom {:type :success :message (str (tr "VIN list emailed successfully"))})
  [!state]
  [list-mode vin-list-1 !state])
